import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyBs_yBEKPd6LQq5WLoaepop7V80W5yjsL0",
  authDomain: "tbtgroup2023-930b4.firebaseapp.com",
  databaseURL: "https://tbtgroup2023-930b4-default-rtdb.firebaseio.com",
  projectId: "tbtgroup2023-930b4",
  storageBucket: "tbtgroup2023-930b4.appspot.com",
  messagingSenderId: "431183440249",
  appId: "1:431183440249:web:6d5a1ecadb56d5f724a7a8",
  measurementId: "G-CECK2YH36M",
};

const firebaseAppTBT = initializeApp(firebaseConfig);

/** Web Push VAPID key — override via REACT_APP_FCM_VAPID_KEY in .env */
const FCM_VAPID_KEY =
  process.env.REACT_APP_FCM_VAPID_KEY ||
  "BJYImomuDimzXM-0R9zLR62hQc4c2xZi4EuibnCJLsmOYeO-3nXUYSM2WnUi9M1yyRglDRBH4YmUdorhVWN-Z2w";

const requestPermission = () => {
  if (
    typeof window === "undefined" ||
    typeof Notification === "undefined" ||
    typeof Notification.requestPermission !== "function"
  ) {
    console.log("Notification API không khả dụng (trình duyệt / HTTP / iOS).");
    return Promise.resolve();
  }
  return Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      console.log("Notification User Permission Granted.");
      return permission;
    }
    console.log("User Permission Denied.");
    return permission;
  });
};

export { firebaseAppTBT, requestPermission, FCM_VAPID_KEY };
